__turbopack_context__.v({
  "arrow": "style-module-scss-module__ThrMOq__arrow",
  "card": "style-module-scss-module__ThrMOq__card",
  "component": "style-module-scss-module__ThrMOq__component",
  "slider": "style-module-scss-module__ThrMOq__slider",
});
